/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useMemo } from 'react';

import { BsTelephoneFill } from 'react-icons/bs';
import { HiChevronDown } from 'react-icons/hi';
import { useBoolean } from 'usehooks-ts';

import { ViewAd } from '@/api/fetch/marketplace-api';
import { AdViewRequest } from '@/api/gen-protos/ads_pb';
import { rudderstackTrackEvent } from '@/api/rudderstack/client';
import Divider, { Orientation } from '@/tayara-kit/Divider';
import Text from '@/tayara-kit/Text';

import { IAdDetailItem } from '../../types';

const ShowPhoneNumberButton = ({
  phoneNumber,
  adDetails,
}: {
  phoneNumber: string;
  adDetails: IAdDetailItem;
}) => {
  const { value: phoneNumberVisible, setTrue: setPhoneNumberVisibleTrue } =
    useBoolean(false);

  function checkos() {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    }

    return 'web';
  }

  const trackAd = async (type: any) => {
    const viewRequest = new AdViewRequest();
    const hours = new Date().getTimezoneOffset() / 60;
    const timezone = new Date().toUTCString().substring(26);
    const TT = timezone + hours;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    // @ts-ignore
    viewRequest.setSessionid(sessionid);
    viewRequest.setAdid(adDetails.id);
    viewRequest.setType(type);
    viewRequest.setLocal('fr');
    viewRequest.setTimezone(TT);
    viewRequest.setUseragent(checkos());

    await ViewAd(viewRequest);
  };

  const track = (eventName: string) => {
    rudderstackTrackEvent(eventName, {
      id: adDetails.id,
      title: adDetails.title,
      category: adDetails.category,
      price: adDetails.price,
      seller_id: adDetails.publisher.id,
    });
  };

  const handleShowPhoneNumberClick = () => {
    setPhoneNumberVisibleTrue();
    // track('Show Phone Number');
    track('Show Phone Number');
    trackAd(2);
  };
  return phoneNumberVisible ? (
    <div className="inline-block font-bold justify-center text-sm p-3">
      <a
        href={`tel:${phoneNumber}`}
        onClick={() => {
          track('Call Phone Number in Description');
        }}
      >
        {phoneNumber}
      </a>
    </div>
  ) : (
    <span className="inline-block p-0 md:p-2 lg:p-2">
      <button
        aria-label="Afficher numéro"
        className="flex items-center text-blue-500 hover:text-blue-600 rounded"
        onClick={() => {
          handleShowPhoneNumberClick();
          track('Show Phone Number in Description');
        }}
      >
        <BsTelephoneFill className="pt-1" />
        <p className="ml-1 mt-1 text-sm">Afficher le numéro</p>
      </button>
    </span>
  );
};

export const phoneNumRe = /(?:[-+() .]*\d){8,11}/gm;
const replacePhoneNumsWithButtons = (
  description: string,
  adDetails: IAdDetailItem
): JSX.Element => {
  let resJSX = <>{description}</>;
  const descriptionWithouPhoneNums = description.split(phoneNumRe);
  const matchedPhoneNums = description.match(phoneNumRe);

  if (matchedPhoneNums !== null) {
    resJSX = (
      <>
        {descriptionWithouPhoneNums.map((textChunk, i) => {
          if (i < matchedPhoneNums.length) {
            return (
              <span key={`show-phone-${i}`}>
                {textChunk}{' '}
                <ShowPhoneNumberButton
                  phoneNumber={matchedPhoneNums[i]!}
                  adDetails={adDetails}
                />
              </span>
            );
          }
          return textChunk;
        })}
      </>
    );
  }

  return resJSX;
};

const ItemDescription = ({ adDetails }: { adDetails: IAdDetailItem }) => {
  // eslint-disable-next-line no-console

  const { value: isExpanded, toggle: toggleExpanded } = useBoolean(false);
  const descriptionJsx = useMemo(
    () => replacePhoneNumsWithButtons(adDetails.description, adDetails),
    [adDetails.description, adDetails]
  );

  return (
    <>
      <Divider orientation={Orientation.HORIZONTAL} />
      <div>
        <Text
          as="h2"
          text="Description"
          className="text-gray-700 font-semibold text-xl mb-4"
        />
        {/* Key vertical button */}
        <p
          dir="auto"
          className={`text-sm text-start text-gray-700 font-arabic whitespace-pre-line	 ${
            !isExpanded ? 'line-clamp-3' : ''
          }`}
          // ref={descriptionRef}
        >
          {descriptionJsx}
        </p>
        {/* Show more button */}

        {adDetails.description.length > 20 ? (
          <button
            className="text-xs flex items-center gap-x-1 text-primary font-medium mt-2"
            onClick={() => toggleExpanded()}
          >
            <Text
              as="span"
              text={`${!isExpanded ? 'Lire plus' : 'Moins'}`}
              className=""
            />
            <HiChevronDown
              size={18}
              className={`${isExpanded ? 'rotate-180' : ''}`}
            />
          </button>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default ItemDescription;
